import React from "react";

import { AkcAgilitySctEntryDto } from "@eagerdog/interfaces";

import styles from "./SCTTable.module.scss";

interface IProps {
  activeTabName: string
  sctData: AkcAgilitySctEntryDto[]
  onRegularValueChange: (rowIndex: number, value: string) => void
  onPreferredValueChange: (rowIndex: number, value: string) => void
}

const SctTable: React.FC<IProps> = ({ activeTabName, sctData, onRegularValueChange, onPreferredValueChange }) => {

  return (
    <div className={styles.sctTable}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>YDS</th>
            <th colSpan={2}>Regular SCT</th>
            <th colSpan={2}>Preferred SCT</th>
          </tr>
        </thead>
        <tbody>
        {sctData.map((row, index) => (
          <tr key={index}>
            <td>
              {row.yds}
            </td>
            <td>
              {row.regular_jump_height}"
            </td>
            <td>
              <input
                id={`${activeTabName}-${row.regular_jump_height}-regular-sct`}
                type="number"
                min={1}
                max={2000}
                value={row.regular_sct ?? ""}
                onChange={(e) => onRegularValueChange(index, e.target.value)}
                className={styles.input}
              />
            </td>
            <td>
              {row.preferred_jump_height}"
            </td>
            <td>
              <input
                id={`${activeTabName}-${row.preferred_jump_height}-preferred-sct`}
                type="number"
                min={1}
                max={2000}
                value={row.preferred_sct ?? ""}
                onChange={(e) => onPreferredValueChange(index, e.target.value)}
                className={styles.input}
              />
            </td>
          </tr>
        ))}
        </tbody>
      </table>
    </div>
  );
};

export { SctTable }
